<template>
  <div>
    <el-form ref="quarterForm" label-width="80px" :model="quarterForm" :rules="quarterFormRules">
      <el-form-item prop="year" label="年份">
        <el-date-picker v-model="quarterForm.year" value-format="yyyy" format="yyyy" type="year" placeholder="选择年" style="width:100%"></el-date-picker>
      </el-form-item>
      <el-form-item label="季度" prop="quarter">
        <el-select v-model="quarterForm.quarter" placeholder="请选择" style="width:100%">
          <el-option :key="index" v-for="(item,index) in quarterOptions" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="center">
      <el-button size="mini" @click="onDownload" type="primary">导出</el-button>
      <el-button size="mini" @click="onCancel">取消</el-button>
    </el-row>
  </div>
</template>
<script>
import rmcProdAuditorApi from "@/api/rmcProduce/audit";
import rmcProdFarmApi from "@/api/rmcProduce/farm";
import rmcProtAuditorApi from "@/api/rmcProtein/audit";
import rmcProtFarmApi from "@/api/rmcProtein/farm";
import rmcProtFeedPlantApi from "@/api/rmcProtein/feedPlant";
import { fileService } from "@/api/common/file-utils";
export default {
  props: ['type'],
  data() {
    return {
      quarterOptions: [
        {
          label: "Q1",
          key: "1",
        },
        {
          label: "Q2",
          key: "2",
        },
        {
          label: "Q3",
          key: "3",
        },
        {
          label: "Q4",
          key: "4",
        }
      ],
      quarterForm: {
        year: "",
        quarter: "",
      },
      quarterFormRules: {
        quarter: [
          { required: true, message: '请选择季度', trigger: 'change' },
        ],
        year: [
          { required: true, message: '请选择年份', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    onDownload() {
      this.$refs['quarterForm'].validate((valid) => {
        if (valid) {
          if (this.type === 'produce_auditor') {
            rmcProdAuditorApi.downloadAuditorQuarterList(this.quarterForm).then(res => {
              fileService.respToFile(res, 'Produce_审核员季度清单.xlsx');
            })
          } else if (this.type === 'produce_farm') {
            rmcProdFarmApi.downloadFarmQuarterList(this.quarterForm).then(res => {
              fileService.respToFile(res, 'Produce_农场季度清单.xlsx');
            })
          } else if (this.type === 'protein_auditor') {
            rmcProtAuditorApi.downloadAuditorQuarterList(this.quarterForm).then(res => {
              fileService.respToFile(res, 'Protein_审核员季度清单.xlsx');
            })
          } else if (this.type === 'protein_farm') {
            rmcProtFarmApi.downloadFarmQuarterList(this.quarterForm).then(res => {
              fileService.respToFile(res, 'Protein_农场季度清单.xlsx');
            })
          } else if (this.type === 'protein_feedplant') {
            rmcProtFeedPlantApi.downloadFeedFactoryQuarterList(this.quarterForm).then(res => {
              fileService.respToFile(res, 'Protein_饲料厂季度清单.xlsx');
            })
          } else if (this.type === 'protein_rmcProtMedUsage') {
            rmcProtFeedPlantApi.exportMedicineUsageSnapshot(this.quarterForm).then(res => {
              fileService.respToFile(res, 'Protein_药品用量季度清单.xlsx');
            })
          }
        }
      })
    },
    onCancel() {
      this.quarterForm = {
        year: "",
        quarter: "",
      }
      this.$emit('onCancelQuarter')
    },
  }
}
</script>